import { render, staticRenderFns } from "./approvalProcess.vue?vue&type=template&id=4c917672&scoped=true&"
import script from "./approvalProcess.vue?vue&type=script&lang=js&"
export * from "./approvalProcess.vue?vue&type=script&lang=js&"
import style0 from "./approvalProcess.vue?vue&type=style&index=0&id=4c917672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c917672",
  null
  
)

export default component.exports